import { Form, FormInstance, Radio, Row, Select } from "antd";
import { useLoadData } from "../../../../Profile/Accounts/hooks/loadData";
import { useMemo } from "react";
import { IOption } from "../../../../../../../../types/Option";
import { CustomerInput } from "./CustomerInput";
import { Rule } from "antd/es/form";
import { useSelectFilterSort } from "../../../../../../../../lib/hooks/useSelectFilterSort";

type CustomerInfoProps = {
  id: string | null | undefined;
  form: FormInstance;
  type: 1 | 2;
  isSaving: boolean;
  customerId: string | undefined;
  setCustomerId: React.Dispatch<React.SetStateAction<string | undefined>>;
};

export const CustomerInfo = ({
  id,
  form,
  type,
  isSaving,
  customerId,
  setCustomerId,
}: CustomerInfoProps) => {
  const { data: accounts, isLoading: isAccountsLoading } =
    useLoadData(customerId);

  const { filterSort } = useSelectFilterSort();

  const accountOptions: IOption[] = useMemo(() => {
    const options: IOption[] = [];

    accounts.forEach((item: any) => {
      const val = options.find((option: IOption) => option.value === item.id);

      !val &&
        options.push({
          value: item.id,
          label: item.accountNumber.toString(),
        });
    });

    return options;
  }, [accounts]);

  const customerContractRoles = useMemo(
    () => [
      {
        label: "Buyer",
        value: 1,
      },
      {
        label: "Seller",
        value: 2,
      },
    ],
    [],
  );

  const isAccListDisabled: boolean = useMemo(() => {
    return !id ? type === 1 || isSaving || isAccountsLoading : true;
  }, [id, type, isSaving, isAccountsLoading]);

  const contractNumberRules: Rule[] = useMemo(() => {
    return [
      () => ({
        validateTrigger: "onSubmit",
        validator(_: Rule, value: any) {
          if (!value) {
            return Promise.reject(new Error("Please select Account #"));
          }
          return Promise.resolve();
        },
      }),
    ];
  }, []);

  return (
    <Row className="d-block w-100 pb-6">
      <p className="mt-0 mb-4 text w-500">Customer Information</p>
      <CustomerInput
        id={id}
        type={type}
        isSaving={isSaving}
        form={form}
        setCustomerId={setCustomerId}
      />
      <Row className="w-100">
        <Form.Item
          className="acc-number-select mb-4 mr-4"
          label="Account #"
          name="contractNumber"
          rules={contractNumberRules}
        >
          <Select
            optionFilterProp="label"
            showSearch
            options={accountOptions}
            disabled={isAccListDisabled}
            loading={isAccountsLoading}
            filterSort={filterSort}
          />
        </Form.Item>
        <Form.Item
          label="Role"
          className="mb-4 customer-role"
          name="customerContractRole"
        >
          <Radio.Group
            options={customerContractRoles}
            optionType="button"
            className="w-100 d-flex"
          />
        </Form.Item>
      </Row>
    </Row>
  );
};
